// extracted by mini-css-extract-plugin
var _1 = "PostBreadcrumbs-module__animatedBackground--DVayM";
var _2 = "PostBreadcrumbs-module__container--WXQ8L";
export { _1 as "animatedBackground", _2 as "container" }
